import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { DashboardFournisseurState } from './state';
import { FactureFournisseurStatsDTO } from '@/models/FactureFournisseurStatsDTO';
import { ReglementDTO } from '@/models/ReglementDTO';

export const getters: GetterTree<DashboardFournisseurState, RootState> = {

    getStatsFactures(state) : FactureFournisseurStatsDTO {
        return state.statsFactures;
    },
    getDerniersReglements(state): ReglementDTO[] {
        return state.reglementsDTO;
    }
};
